import React from 'react';
import { Route } from 'react-router-dom';

const ClaimImportStatus = React.lazy(() => import('../containers/ClaimImportStatus'));
const CustomDataFields = React.lazy(() => import('../containers/CustomDataFields'));
const GenerateInterface = React.lazy(() => import('../containers/GenerateInterface'));
const ImportClaimsAndPayments = React.lazy(() => import('../containers/ImportClaimsAndPayments'));
const ManageMapFiles = React.lazy(() => import('../containers/ManageMapFiles'));
const RegisterInvoice = React.lazy(() => import('../containers/RegisterInvoice'));
const ATGHome = React.lazy(() => import('../containers/ATG'));
const FileConverter = React.lazy(() => import("../containers/FileConverter"));
const DocumentsManagerHistory = React.lazy(() => import("../containers/DocumentsManagerHistory"));
const DocumentsManager = React.lazy(() => import("../containers/DocumentsManager"));

export default [
    <Route key='/claims-import-status' path='/claims-import-status' element={<ClaimImportStatus />} />,
    <Route key='/custom-data-fields' path={'/custom-data-fields'} element={<CustomDataFields />} />,
    <Route key='/generate-interface' path={'/bugenerate-interfacelk'} element={<GenerateInterface />} />,
    <Route key='/import-claims-and-payments' path={'/import-claims-and-payments'} element={<ImportClaimsAndPayments />} />,
    <Route key='/manage-map-files' path={'/manage-map-files'} element={<ManageMapFiles />} />,
    <Route key='/register-invoice' path={'/register-invoice'} element={<RegisterInvoice />} />,
    <Route key='/file-converter' path={'/file-converter'} element={<FileConverter />} />,
    <Route key='/atg' path={'/atg'} element={<ATGHome />} />,
    <Route key='/import-and-process-documents' path={'/import-and-process-documents'} element={<DocumentsManager />} />,
    <Route key='/documents-manager-history' path={'/documents-manager-history'} element={<DocumentsManagerHistory />} />,

    <Route key='/' path={'/'} element={<></>} />
]